// extracted by mini-css-extract-plugin
export var baseButton = "_uu-0";
export var controlsArrowKeys = "_uu-1";
export var controlsResetButton = "_uu-2";
export var lightGameButton = "_uu-4 _uu-0";
export var playAgainButton = "_uu-5 _uu-0";
export var startGameButton = "_uu-3 _uu-0";